/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import {
  COMPANY_DATA,
  GET_COUNTS_FAILURE,
  GET_COUNTS_REQUEST,
  GET_COUNTS_SUCCESS,
  GET_HP_FAILURE,
  GET_HP_REQUEST,
  GET_HP_SUCCESS,
  LOGOUT_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  MFA_COMPLETE,
  MFA_PENDING,
  PROFILE_DATA,
  SIGN_IN_FAILURE,
  SIGN_IN_REQUEST,
  SIGN_IN_SUCCESS,
} from "../actions/auth";
import { AuthState } from "../init-state";

const auth = (state = AuthState, { type, payload }) => {
  switch (type) {
    case SIGN_IN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case SIGN_IN_SUCCESS:
      return {
        ...state,
        authData: payload,
        loading: false,
        error: null,
      };

    case SIGN_IN_FAILURE:
      return {
        ...state,
        authData: null,
        loading: false,
        error: payload,
      };

    case LOGOUT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    // Drop every trace of the session, not just authData. profile/company left
    // behind outlive the logout in the same tab and would seed the next login
    // (or the login page itself) with the previous user's data.
    case LOGOUT_SUCCESS:
      return {
        ...state,
        authData: null,
        profile: null,
        company: null,
        loading: false,
        error: null,
      };

    case LOGOUT_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_COUNTS_REQUEST:
      return {
        ...state,
        error: null,
      };

    case GET_COUNTS_SUCCESS:
      return {
        ...state,
        counts: payload,
        error: null,
      };

    case GET_COUNTS_FAILURE:
      return {
        ...state,
        error: payload,
      };

    case GET_HP_REQUEST:
      return {
        ...state,
        error: null,
      };

    case GET_HP_SUCCESS:
      return {
        ...state,
        hp: payload,
        error: null,
      };

    case GET_HP_FAILURE:
      return {
        ...state,
        error: payload,
      };

    case PROFILE_DATA:
      return {
        ...state,
        profile: payload,
      };

    case COMPANY_DATA:
      return {
        ...state,
        company: payload,
      };

    // Credentials verified; awaiting TOTP code — store the pre-auth token in Redux only (not localStorage).
    case MFA_PENDING:
      return {
        ...state,
        loading: false,
        error: null,
        mfa: payload,
      };

    case MFA_COMPLETE:
      return {
        ...state,
        mfa: null,
      };

    default:
      return state;
  }
};

export default auth;
